export const SET_REPORTS = 'SET_REPORTS'
export const SET_BATCH_TYPES = 'SET_BATCH_TYPES'
export const SET_POST_BATCHES = 'SET_POST_BATCHES'
export const SET_SELECTED_BATCHES = 'SET_SELECTED_BATCHES'
export const SET_POST_BATCH_PAYMENTS = 'SET_POST_BATCH_PAYMENTS'
export const SET_TOTALS_VALID = 'SET_TOTALS_VALID'

const initialState = {
  reports: [],
  batchTypes: [],
  batches: [],
  selectedBatches: [],
  payments: [],
  areTotalsValid: false,
}

const PostPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORTS:
      return { ...state, reports: action.reports }
    case SET_BATCH_TYPES:
      return { ...state, batchTypes: action.batchTypes }
    case SET_POST_BATCHES:
      return { ...state, batches: action.batches }
    case SET_SELECTED_BATCHES:
      return { ...state, selectedBatches: action.selectedBatches }
    case SET_POST_BATCH_PAYMENTS:
      return { ...state, payments: action.payments }
    case SET_TOTALS_VALID:
      return { ...state, areTotalsValid: action.areTotalsValid }
    default:
      return state
  }
}

export default PostPaymentReducer
